import React, { useEffect } from "react";
import { useAppDispatch } from "../../_App/Redux/hooks";
import { SubmitHandler, useForm } from "react-hook-form";
import { Button, Modal } from "react-bootstrap";
import { HolidayType } from "../../_App/Types/Entites/HolidayType";
import {
  savePublicHolidayOrWeekend,
  updatePublicHolidayOrWeekend,
} from "../../_App/Redux/Slices/holidays/holidaysSlice";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2"; // Import SweetAlert2

const HolidayForm = ({
  showModal,
  setShowModal,
  date,
  refresh,
  setRefresh,
  selectedEvent,
  setSelectedEvent,
}: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<HolidayType>();

  useEffect(() => {
    if (selectedEvent) {
      reset({
        date: selectedEvent.date,
        nom: selectedEvent.title,
        pays: selectedEvent.location,
        type: selectedEvent.type,
        day: selectedEvent.day,
      });
    } else {
      reset({
        date: new Date(date).toLocaleDateString("en-CA"),
        nom: "",
        pays: "Tunisia",
        recurring: 0,
        type: "ferie",
        day: null,
      });
    }
  }, [showModal]);

  const closeModal = () => {
    setShowModal(false);
  };

  const onSubmit: SubmitHandler<HolidayType> = async (data) => {
    console.log("Form Data:", data);

    const confirmation = await Swal.fire({
      title: t("Êtes-vous sûr ?"),
      text: t("Vous êtes sur le point d'ajouter un jour férié."),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Oui, enregistrer !"),
      cancelButtonText: t("Annuler"),
    });

    if (confirmation.isConfirmed) {
      if (selectedEvent) {
        // Pass the updated data to the update function
        const res = await dispatch(
          updatePublicHolidayOrWeekend({
            id: selectedEvent.id,
            data: { nom: data.nom },
          })
        );
        Swal.fire({
          title: t("Succès !"),
          text: t("Le jour férié a été modifié avec succès."),
          icon: "success",
          confirmButtonText: t("OK"),
        });
        closeModal(); // Close the modal after success
        setRefresh(!refresh);
      } else {
        const holidaysData = [data];
        const res = await dispatch(savePublicHolidayOrWeekend(holidaysData));

        if (res.payload.success) {
          // Success alert
          Swal.fire({
            title: t("Succès !"),
            text: t("Le jour férié a été ajouté avec succès."),
            icon: "success",
            confirmButtonText: t("OK"),
          });
          closeModal(); // Close the modal after success
          setRefresh(!refresh);
        }
      }
    }
  };

  return (
    <Modal show={showModal} onHide={closeModal}>
      <Modal.Header>
        <Modal.Title>
          <span className="modal-title" id="addCategorieLabel">
            <i className="mdi mdi-plus-circle text-primary mr-1" />{" "}
            {t("Ajouter un jour férié")}
          </span>
        </Modal.Title>
        <button
          type="reset"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={closeModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="card-body">
          {selectedEvent ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div
                  className="col-12"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="form-group" style={{ width: "100%" }}>
                    <label htmlFor="nom">
                      {t("Libellé")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("nom", { required: true })}
                    />
                  </div>
                </div>
              </div>

              <Button
                variant="primary"
                type="submit"
                className="mr-2 float-right"
              >
                {t("Enregistrer")}
              </Button>
              <Button
                variant="secondary"
                className="mr-2 float-right"
                onClick={closeModal}
              >
                {t("Supprimer")}
              </Button>
            </form>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div
                  className="col-12"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="form-group" style={{ width: "100%" }}>
                    <label htmlFor="nom">
                      {t("Libellé")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("nom", { required: true })}
                    />
                    {errors.nom && (
                      <span className="text-danger">
                        {t("Ce champ est requis")}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <Button
                variant="primary"
                type="submit"
                className="mr-2 float-right"
              >
                {t("Enregistrer")}
              </Button>
              <Button
                variant="secondary"
                className="mr-2 float-right"
                onClick={closeModal}
              >
                {t("Annuler")}
              </Button>
            </form>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HolidayForm;
